/** keep this file light, and dont use/import other files
 * this file is needed to be loaded
 *  and initialized before rest of the application
 */

import React from 'react';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';
import {CONFIG_DATA_BASE_KEYS, LAYOUT_IDS, PAM_WELCOME_LOGO} from 'Utils/constants';
import '../../scss/preloader.scss';
import PreloaderComponent from './PreloaderComponent';

const ExplorerPreloader = () => {
    const [data, setData] = React.useState({});
    const [progress, setProgress] = React.useState(0);

    let interval;
    const getData = () => {
        clearInterval(interval);
        let welcomeImage;
        const preloadedData = window.__INITIAL_STATE__?.data || window.__INITIAL_STATE__;
        if (preloadedData !== 'API_ERROR') {
            const activeSceneId = preloadedData.scenes.find(s => s.isActive).id;

            const layoutConfigGlobalKioskActiveScene = preloadedData.layoutConfigs.find(
                _layoutConfig =>
                    _layoutConfig.layoutId === LAYOUT_IDS.KIOSK &&
                    !_layoutConfig.digitalSignId &&
                    _layoutConfig.sceneId === activeSceneId
            );
            welcomeImage =
                layoutConfigGlobalKioskActiveScene?.config?.[CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE]
                    ?.idleScreen?.welcomeImage?.url;

            if (!welcomeImage) {
                const defaultSceneId = preloadedData.scenes.find(s => s.isDefault).id;
                const layoutConfigGlobalKioskDefaultScene = preloadedData.layoutConfigs.find(
                    _layoutConfig =>
                        _layoutConfig.layoutId === LAYOUT_IDS.KIOSK &&
                        !_layoutConfig.digitalSignId &&
                        _layoutConfig.sceneId === defaultSceneId
                );
                welcomeImage =
                    layoutConfigGlobalKioskDefaultScene?.config?.[
                        CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE
                    ]?.idleScreen?.welcomeImage?.url;
            }
        }
        setData({
            projectName: preloadedData?.settings?.projectName || 'PAM',
            logo: welcomeImage,
        });
    };

    React.useEffect(() => {
        interval = setInterval(() => {
            if (window.__INITIAL_STATE__) getData();
        }, 50);

        const animationInterval = setInterval(() => {
            setProgress(_progress => _progress + 8);
        }, 500);

        return () => {
            clearInterval(interval);
            clearInterval(animationInterval);
        };
    }, []);

    return (
        <div className="preloader-wrapper-container">
            {/* only shows after getData */}
            {!!data.projectName && (
                <div className="preloader-wrapper">
                    <div className="preloader-body-wrapper">
                        <div className="preloader-branding-image">
                            <img
                                alt={data.projectName}
                                src={
                                    data.logo
                                        ? prependDigitalAssetsUrl(data.logo)
                                        : PAM_WELCOME_LOGO
                                }
                                height="100%"
                            />
                        </div>
                        <div className="preloader-text-wrapper">
                            <div>
                                <p className="preloader-title">
                                    {data.projectName && (
                                        <span>
                                            Welcome to <br /> {data.projectName}
                                        </span>
                                    )}
                                </p>
                                <p className="preloader-underscore" />
                                <p className="preloader-sub-title">LET&apos;S GET YOU THERE</p>
                            </div>
                            <PreloaderComponent progress={progress} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExplorerPreloader;
